import templateUrl from './eventPanelTile.tpl.html';

angular.module('signalview.eventsPanel').directive('eventPanelTile', [
    'eventModal',
    'alertingService',
    function (eventModal, alertingService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                event: '=',
                eventColors: '<?',
            },
            templateUrl,
            link: function ($scope) {
                $scope.showInfo = function () {
                    const event = $scope.event;
                    if (
                        alertingService.shouldOpenAlertDetailsPage() &&
                        event?.metadata?.sf_eventCategory === 'ALERT' &&
                        event?.id
                    ) {
                        alertingService
                            .getCurrentPageNavigationContext()
                            .then((navigationContext) => {
                                alertingService.navigateToAlertDetails(event.id, navigationContext);
                            });
                        return;
                    }

                    eventModal(event);
                };

                $scope.enterEventTile = function () {
                    $scope.$emit('eventTileMouseEnter', $scope.event.timestamp);
                };

                $scope.leaveEventTile = function () {
                    $scope.$emit('eventTileMouseLeave');
                };
            },
        };
    },
]);
